@if (isMobileSmDown() && isUndoVisible()) {
  <div class="cart-undo-delete-toast">
    <div class="cart-undo-delete-toast-timer text-b3-s-500">
      <sd-progress-circle [seconds]="secondsLeft()" [initialSeconds]="initialSeconds" />
      <span class="cart-undo-delete-toast-timer-text">товар удален</span>
    </div>
    <div class="cart-undo-delete-toast-cancel">
      <button class="link-white link-hover-underlined link-underlined text-b3-s-300" (click)="undo()">отменить</button>
    </div>
  </div>
}
